
import { Directive, Input, ViewContainerRef } from '@angular/core';
import { INode } from '@feature/nodes/models/node-type';
import { NodeComponentRendererFactoryService } from '../services/node-component-factory.service';
import { NGXLogger } from 'ngx-logger';

@Directive({
  selector: '[appRenderNode]'
})
export class RenderNodeDirective {

  constructor(private vcr: ViewContainerRef,
              private readonly nodeComponentFactoryService: NodeComponentRendererFactoryService,
              private readonly logger : NGXLogger) { }

  @Input() appRenderNode: INode;
  
  ngOnInit(): void {
    const nodeName = this.appRenderNode.Name;
    const nodeRenderer = this.nodeComponentFactoryService.getRenderer(nodeName);
    if(!nodeRenderer)
    {
      this.logger.error(`No composite renderer was found for a node of name '${nodeName}'; this might mean that it has yet to be developed.`);
      return;
    }

    nodeRenderer(this.vcr, this.appRenderNode);
  }
}
